/**
 * @param {*} [value]
 * @returns {boolean} true for null, undefined and the empty string
 */
export function isEmpty(value) {
  return value === null || value === undefined || value === '';
}

/**
 * @param {*} [value]
 * @returns {boolean}
 */
export function notEmpty(value) {
  return !isEmpty(value);
}